import { consola } from 'consola'
import { useInstitutionStore, getReadyInstitutionId } from '@entities/institution'

/**
 * SSR-prefetch данных заведения.
 *
 * Универсальный плагин: Nuxt дожидается его до рендера.
 * На website (SSR) выполняется на сервере → стор заполняется ДО renderToString,
 * поэтому seo_meta (title/description/og), название заведения и меню попадают
 * в серверный HTML и индексируются поисковиками. Pinia-стейт сериализуется в
 * payload и гидрируется на клиенте без повторного запроса.
 *
 * На mobile-сборке (ssr:false) выполняется на клиенте — поведение как раньше.
 *
 * Клиентскую инициализацию (профиль, корзина) делает layouts/default.vue в onMounted —
 * здесь грузим только публичные данные, нужные для SEO.
 */
export default defineNuxtPlugin({
  name: 'institution-ssr',
  async setup(nuxtApp) {
    // Привязываемся к request-scoped инстансу Pinia (иначе на сервере данные
    // попадут в «чужой» стор и не сериализуются в payload).
    const store = useInstitutionStore(nuxtApp.$pinia as never)

    // Уже загружено (гидрация payload на клиенте) — повторно не дёргаем API.
    if (store.branches?.length) return

    try {
      const id = await getReadyInstitutionId()
      await store.fetchBranches(id)

      // Активный филиал по умолчанию (как делает вотчер cities на клиенте),
      // чтобы в HTML попали и меню, и корректный город.
      const branch = store.branches?.find(b => b.is_active !== false) ?? store.branches?.[0]
      if (branch?.id) {
        if (!store.selectedBranchId) store.setSelectedBranchId(branch.id)
        await store.fetchProducts(branch.id)
      }
      consola.debug('[institution-ssr] prefetched:', store.institution?.name, '| branches:', store.branches?.length, '| categories:', store.products?.length)
    } catch (error) {
      // API недоступен на SSR — рендерим оболочку с дефолтными мета, а не 500.
      consola.error('[institution-ssr] prefetch failed:', error)
    }
  },
})
